export const returnFormattedWeightDescription = (weight) => {
  if (weight < 1000) {
    return `${weight}g`;
  }
  return `${weight / 1000}kg`;
};
